module.exports = __webpack_public_path__ + "static/media/asset-icon-active.e2095b15.svg";